import React from 'react'
import { observer } from 'mobx-react-lite'

import { InstitutionLogo, CategoryIcon } from '@mxenabled/mxui'

import { useAccountStore, useBudgetsStore, useGlobalCopyStore } from '../../common'
import { type Notification } from '../../core'

interface NotificationBadgeProps {
  notification: Notification
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ notification }) => {
  // Show notifications for all accounts (including hidden)
  const { accounts } = useAccountStore()
  const { budgets } = useBudgetsStore()
  const { accounts: accountsCopy } = useGlobalCopyStore()

  const account = accounts.find((account) => account.guid === notification.entity_guid)
  const budget = budgets.find((budget) => budget.guid === notification.entity_guid)
  const isGoal = notification.entity_guid.includes('GOL')

  const styles = {
    badge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      marginRight: 12,
    },
  }

  if (account || isGoal) {
    return (
      <div style={styles.badge}>
        <InstitutionLogo
          alt={account?.institutionName || accountsCopy.institution_logo_alt}
          institutionGuid={account?.institution_guid ?? ''}
          size={33}
        />
      </div>
    )
  } else {
    return (
      <div style={styles.badge}>
        <CategoryIcon categoryGuid={budget?.category_guid} size={36} />
      </div>
    )
  }
}

export default observer(NotificationBadge)
